import { TSavedLaneSchema } from 'transfix-form/forms/SavedLaneForm/schema'
import {
  getSavedLaneSchemaDateType,
  getSavedLaneSchemaDaysOfWeek,
  getSavedLaneSchemaEquipment,
  getSavedLaneSchemaLane,
  getSavedLaneSchemaRateType,
} from 'transfix-form/forms/SavedLaneForm/utils'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'

/**
 * Returns a TSavedLaneSchemaObject from a BookableShipmentSavedSearch
 */
export const getFMSSavedLaneSchema = (
  savedSearch: BookableShipmentSavedSearch
): TSavedLaneSchema => {
  const {
    deliveryCity,
    deliveryMiles,
    deliveryStateCode,
    hasNotificationsEnabled,
    motorCarrier,
    pickupCity,
    pickupIsoDaysOfWeek = [],
    pickupMiles,
    pickupStartDate = '',
    pickupStateCode,
    rate,
    rateType,
    trailerType,
  } = savedSearch || {}

  const { id: motorCarrierId } = motorCarrier || {}

  return {
    lane: getSavedLaneSchemaLane({
      pickupCity,
      pickupStateCode,
      pickupMiles,
      deliveryCity,
      deliveryStateCode,
      deliveryMiles,
    }),
    dateType: getSavedLaneSchemaDateType({ pickupIsoDaysOfWeek, pickupStartDate }),
    equipment: getSavedLaneSchemaEquipment(trailerType),
    rateType: getSavedLaneSchemaRateType(rateType || null),
    rate: rate || null,
    daysOfWeek: getSavedLaneSchemaDaysOfWeek(pickupIsoDaysOfWeek),
    date: pickupStartDate || null,
    motorCarrierId: `${motorCarrierId}` || '',
    receiveNotifications: hasNotificationsEnabled || false,
    recipients: [], // This field is not used in FMS
  }
}
